export class Login {
    emailAddr: string;
    password: string;
    captcha?:string;
}
